import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux'
import { withStyles } from '@material-ui/core';

import { WaitingListIcon as View } from './WaitingListIcon'

import { modalActions } from 'reduxModules/actions/ModalActions'
import {
  waitingPassengersQtySelector
} from 'reduxModules/selectors/RouteSelectors'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  waitingPassengersQty: waitingPassengersQtySelector
})

const mapDispatchToProps = {
  showModal: modalActions.showModal,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const WaitingListIcon = enhance(View)


// WEBPACK FOOTER //
// ./src/components/WaitingListIcon/index.js